import React, {Suspense, lazy} from 'react';
import {useSelector, shallowEqual} from 'react-redux';
import {Route, Switch} from 'react-router-dom';
import {TransitionGroup, CSSTransition} from 'react-transition-group';

import PageLoader from './components/PageLoader';
import PrivateRoute from './components/PrivateRoute';

const Main = lazy(() => import('./pages/Main'));
const AddArticle = lazy(() => import('./pages/AddArticle'));
const Article = lazy(() => import('./pages/Article'));
const EditArticle = lazy(() => import('./pages/EditArticle'));
const EditUser = lazy(() => import('./pages/EditUser'));
const Auth = lazy(() => import('./pages/Auth'));
const Keypad = lazy(() => import('./pages/Keypad'));
const User = lazy(() => import('./pages/User'));
const Dashboard = lazy(() => import('./pages/Admin/Dashboard'));
const addUser = lazy(() => import('./pages/Admin/Auth'));
const Chat = lazy(() => import('./pages/Chat'));
const Messages = lazy(() => import('./pages/Messages'));
const UsersChat = lazy(() => import('./pages/UsersChat'));
const Users = lazy(() => import('./pages/Users'));
const AllUsers = lazy(() => import('./pages/Admin/Users'));
const Door = lazy(() => import('./pages/Door'));
const NotFound = lazy(() => import('./components/NotFound'));

const Routes = () => {
	const auth = useSelector(state => state.auth, shallowEqual);

	return (
		<Route
			render={({location}) => (
				<TransitionGroup className='transition-group'>
					<CSSTransition key={location.key} timeout={300} classNames={'fade'}>
						<Suspense fallback={<PageLoader />}>
							<section className='route-section'>
								<Switch location={location}>
									<PrivateRoute
										exact
										path='/'
										condition={!auth.isAuth}
										component={Auth}
										redirectTo='/home'
									/>
									<PrivateRoute path='/home' component={Main} condition={auth.isAuth} />
									<PrivateRoute
										path='/chat'
										component={Chat}
										condition={auth.isAuth}
										redirectTo='/auth'
									/>
									<PrivateRoute
										path='/keypad'
										component={Keypad}
										condition={auth.isAuth}
										redirectTo='/auth'
									/>
									<Route exact path='/user/:link' component={User} />
									<PrivateRoute
										component={AddArticle}
										condition={auth.isAuth}
										redirectTo='/auth'
										path='/article/add'
									/>
									<PrivateRoute
										exact
										path='/article/:slug'
										component={Article}
										condition={auth.isAuth}
										redirectTo='/auth'
									/>
									<PrivateRoute
										component={EditArticle}
										condition={auth.isAuth}
										redirectTo='/auth'
										path='/article/:slug/edit'
									/>
									<PrivateRoute
										component={EditUser}
										condition={auth.isAuth}
										redirectTo='/auth'
										path='/user/:link/edit'
									/>
									<PrivateRoute
										component={Auth}
										condition={!auth.isAuth}
										redirectTo={location.state && location.state.from.pathname && '/home'}
										path='/auth'
									/>
									<PrivateRoute
										component={Messages}
										condition={auth.isAuth}
										redirectTo='/auth'
										path='/messages'
									/>
									<PrivateRoute
										component={UsersChat}
										condition={auth.isAuth}
										redirectTo='/auth'
										path='/users-chat/:userId'
									/>
									<PrivateRoute
										component={Door}
										condition={auth.isAuth}
										redirectTo='/auth'
										path='/door'
									/>
									<PrivateRoute
										component={Users}
										condition={auth.isAuth}
										redirectTo='/auth'
										path='/users'
									/>
									<PrivateRoute
										component={Dashboard}
										condition={auth.isAdmin}
										redirectTo='/auth'
										path='/admin/dashboard'
									/>
									<PrivateRoute
										component={addUser}
										condition={auth.isAdmin}
										redirectTo='/auth'
										path='/admin/addUser'
									/>
									<PrivateRoute
										component={AllUsers}
										condition={auth.isAdmin}
										redirectTo='/auth'
										path='/admin/users'
									/>

									<Route component={NotFound} />
								</Switch>
							</section>
						</Suspense>
					</CSSTransition>
				</TransitionGroup>
			)}
		/>
	);
};

export default Routes;
